import * as React from 'react'
import styled from 'styled-components'

import { Box, Button, TextBody, upToMd } from '@ally/metronome-ui'
import { GuestEnrollConfirmationProps } from '@ally/transmitigator'
import { LoginHeading } from '@ally/ally-login'

import { WelcomeSvg } from '../svgs/Welcome'
import { useTransmit } from '../../TransmitContext'
import { useAppState } from '../../AppStateProvider'

const StyledBox = styled(Box)`
  display: flex;
  flex-direction: column;
`

const StyledBoxWrapper = styled(Box)`
  ${({ theme: { media } }): string => `
    max-width: 575px;
    align-self: center;
    textAlign: center;
      order: 1;
      ${media.down('md')} {
        max-width: 450px;
        order: 2;
      }
    `}
`

const StyledSvgWrapper = styled(Box)`
  ${({ theme: { media } }): string => `
      width: 50%;
      max-width: 600px;
      order: 1;
      align-self: center;
      ${media.down('md')} {
        width: 215px;
      }
    `}
`

const StyledTextBody = styled(TextBody)`
  text-align: center;
`

export const GuestConfirmationContent: React.FC<GuestEnrollConfirmationProps> = ({
  onComplete,
  status,
  error,
}) => {
  const { hostServices } = useTransmit()
  const { isWebWrapped } = useAppState()

  React.useEffect(() => {
    hostServices?.analytics.trackPageView({
      eventType: 'pageview',
      pageName: 'AOS:Login:Guest Enrollment:Confirmation',
    })
  }, [])

  const handleConfirm = (): void => {
    onComplete()
  }

  return (
    <StyledBox data-testid="guest-login-page-wrapper">
      <StyledSvgWrapper data-testid="welcome-image">
        <WelcomeSvg />
      </StyledSvgWrapper>

      <StyledBoxWrapper data-testid="confirmation-wrapper">
        <LoginHeading title="You're in." />
      </StyledBoxWrapper>
      <StyledBoxWrapper data-testid="confirmation-wrapper">
        <Box mb="lg" display="flex" width={upToMd<any, any>(12, 12) as any}>
          <StyledTextBody tag="p" size="md" data-testid="confirmation-subcopy">
            You&apos;re ready to get started with our financial tools. You can
            edit your information any time in your
            <TextBody tag="span" weight="bold" size="md">
              {' '}
              Profile and Settings.
            </TextBody>
          </StyledTextBody>
        </Box>
      </StyledBoxWrapper>
      <StyledBoxWrapper data-testid="confirmation-wrapper">
        <Button
          text={isWebWrapped ? 'Log in' : 'Continue'}
          fullWidthMd
          variant="primary"
          onClick={handleConfirm}
          allytmln="guestEnrollmentComplete-continue"
        />
      </StyledBoxWrapper>
    </StyledBox>
  )
}

export const GuestConfirmation: React.FC = () => {
  const { activeScreen } = useTransmit()

  if (activeScreen.type !== 'GuestConfirmation') {
    return null
  }

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <GuestConfirmationContent {...activeScreen.payload} />
}
